// ./src/components/generic/StatusBadge/StatusBadge.tsx
import React from "react";
import { Badge } from "@mantine/core";
import { PROGRESS_STYLE_OPTIONS } from "../ProgressStyleSelector";

export interface ProgressStyleBadgeProps {
  value?: string | undefined | null;
}

const statuses: any = [
  { value: "", label: "Unknown" },
  ...PROGRESS_STYLE_OPTIONS,
].reduce((acc: any, option: any) => {
  acc[option.value] = option.label;
  return acc;
}, {});

export const ProgressStyleBadge: React.FC<ProgressStyleBadgeProps> = ({
  value,
}) => {
  const badgeInfo = statuses[value != null ? value : ""];

  return (
    <Badge color={badgeInfo.color} variant="light" size="sm">
      {badgeInfo.label}
    </Badge>
  );
};
